import appConfig from '@/constants';

let { httpType, host, port } = appConfig;

let preBaseUrl = `${httpType}://${host}`;
if (port) {
  preBaseUrl = `${preBaseUrl}:${port}`;
}

export let baseUrl = preBaseUrl;
export let version = process.env.VUE_APP_ENV === 'development' ? `` : `p/wujing/back`;

export let baseUrlFull = version ? `${baseUrl}/${version}` : baseUrl;
